import CustomTextInput from "@components/input/CustomTextInput";
import { useFormContext } from "react-hook-form";
import { IFormInput } from "../JoinPage";
import styled from "@emotion/styled";
import LabelWithInput from "@components/input/LabelWithInput";

export default function Password() {
  const {
    formState: { dirtyFields, errors },
  } = useFormContext<IFormInput>();

  return (
    <InputWrapper>
      <LabelWithInput label={"비밀번호"} required={true}>
        <CustomTextInput
          type="password"
          width="100%"
          placeholder="비밀번호 입력"
          message="영문 + 숫자 포함 8-20자 이내"
          name="password"
          isPasswordField={true} // 문구 view 설정
          success={!!dirtyFields.password && !errors.password}
        />
        <CustomTextInput
          type="password"
          width="100%"
          placeholder="비밀번호 재확인"
          message="비밀번호 재확인"
          name="passwordConfirm"
          isPasswordField={true}
          success={!!dirtyFields.passwordConfirm && !errors.passwordConfirm}
        />
      </LabelWithInput>
    </InputWrapper>
  );
}
const InputWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: "1.8rem",
  flexGrow: 1,
});
